"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getNextSupplyIndex = exports.scrollTo = exports.countMeters = exports.filterSupplies = exports.filterTimingCategory = exports.mapKapiMeterReadToLegacy = exports.mapKapiElectricityMeterReadToLegacy = exports.hasComplexSuppliesContext = exports.groupSupplies = exports.getSupplyIndex = exports.timeOfUseLabelToTimingCategory = exports.timingCategoryToTimeOfUseLabel = exports.hasComplexSupplies = exports.getTiersByRegisters = exports.getLatestMeterExchangeReading = exports.mostRecentFirst = exports.getSupplyMeterInfo = exports.filterReadsMPXN = exports.mapMPXN = exports.useWindowDimensions = exports.getReadingTypeLabel = exports.isSupplyMultirate = exports.isReadingsMultirate = exports.hasRequiredSearchParams = exports.isEstimatedReadingType = exports.hasManualReadingToday = exports.applyLeadingZeros = exports.hasLatestLocalReading = exports.storeLatestReadingLocal = void 0;
var date_fns_1 = require("date-fns");
var react_1 = require("react");
var __generated__1 = require("../../../shared/api/kapi/v1/__generated__/");
var core_1 = require("../../../shared/core");
var groupBy_1 = require("../../../shared/core/utils/groupBy");
var supply_points_1 = require("../../billing/utils/supply-points");
var constants_1 = require("../constants");
var storeLatestReadingLocal = function (mpxn) {
    var storedReadings = JSON.parse(localStorage.getItem(constants_1.SUBMIT_READ_STORAGE_KEY) || '[]')
        .filter(function (_a) {
        var sprn = _a.sprn;
        return sprn !== mpxn;
    })
        .concat({
        dateTime: (0, date_fns_1.startOfToday)(),
        sprn: mpxn,
    });
    localStorage.setItem(constants_1.SUBMIT_READ_STORAGE_KEY, JSON.stringify(storedReadings));
};
exports.storeLatestReadingLocal = storeLatestReadingLocal;
var hasLatestLocalReading = function (mpxn) {
    if (!mpxn) {
        return false;
    }
    var storedReadings = localStorage.getItem(constants_1.SUBMIT_READ_STORAGE_KEY);
    var latestReading = (storedReadings
        ? JSON.parse(storedReadings)
        : []).find(function (_a) {
        var sprn = _a.sprn;
        return sprn === mpxn;
    });
    return (!!latestReading &&
        !!latestReading.dateTime &&
        (0, date_fns_1.isToday)(latestReading.dateTime));
};
exports.hasLatestLocalReading = hasLatestLocalReading;
function applyLeadingZeros(meterNumOfDigits, meterReading) {
    if (!meterNumOfDigits || !String.prototype.padStart) {
        return "".concat(meterReading);
    }
    var _a = __read("".concat(meterReading).split('.'), 2), beforeDecimal = _a[0], afterDecimal = _a[1];
    var paddedValue = beforeDecimal.padStart(meterNumOfDigits, '0');
    if (!afterDecimal) {
        return paddedValue;
    }
    return "".concat(paddedValue, ".").concat(afterDecimal);
}
exports.applyLeadingZeros = applyLeadingZeros;
function hasManualReadingToday(readings, mpxn) {
    return ((0, exports.hasLatestLocalReading)(mpxn) ||
        !!readings.find(function (read) {
            return read.readingType === 'CustomerSubmittedReading' &&
                (0, date_fns_1.isToday)(new Date(read.readingDateTime)) &&
                (!mpxn || mpxn === read.mpxn);
        }));
}
exports.hasManualReadingToday = hasManualReadingToday;
function isEstimatedReadingType(readingType) {
    return readingType.includes('Estimate');
}
exports.isEstimatedReadingType = isEstimatedReadingType;
var hasRequiredSearchParams = function (urlSearchParams) {
    //isPending param is optional
    var searchKeys = Array.from(urlSearchParams.keys());
    var commonParams = ['fuel', 'readingDate'];
    var readParams = [
        'meterReading',
        'peakMeterReading',
        'offpeakMeterReading',
        'anytimeMeterReading',
        'heatingMeterReading',
        'eveningAndWeekendMeterReading',
    ];
    var hasCommonParams = commonParams.every(function (x) { return searchKeys.includes(x); });
    var hasReadParams = readParams.some(function (x) { return searchKeys.includes(x); });
    if (hasCommonParams && hasReadParams) {
        return true;
    }
    return false;
};
exports.hasRequiredSearchParams = hasRequiredSearchParams;
function isReadingsMultirate(reading) {
    if ('tiers' in reading) {
        return reading.tiers.length > 1;
    }
    return false;
}
exports.isReadingsMultirate = isReadingsMultirate;
function isSupplyMultirate(supply) {
    if (supply.supplyPointInfo && 'registers' in supply.supplyPointInfo) {
        return Boolean(supply.supplyPointInfo.registers && // CPCE-1730: invalid response type.
            supply.supplyPointInfo.registers.length > 1);
    }
    return false;
}
exports.isSupplyMultirate = isSupplyMultirate;
// See https://ovotech.atlassian.net/wiki/spaces/OEP/pages/4103668315/How+it+works+Meter+reading+type+and+hierarchy
function getReadingTypeLabel(readingType) {
    switch (readingType) {
        case 'CorrectionReadActual':
        case 'CustomerReadingContactCentre':
        case 'CustomerSubmittedReading':
        case 'FinalReadingActual':
        case 'MexReadingFinal':
        case 'MexReadingInitial':
        case 'MigrationReadingActual':
        case 'OnSiteReading':
        case 'OpeningReadingActual':
            return 'Manual';
        case 'MexReadingFinalEstimated':
        case 'MexReadingInitialEstimated':
        case 'MexReadingInitialDeemed':
        case 'OpeningReadingDeemed':
        case 'OpeningReadingAgreed':
        case 'CorrectionReadEstimate':
        case 'EstimatedReading':
        case 'MigrationReadingEstimated':
            return 'Estimated';
        case 'SmartReading':
            return 'Smart';
        default:
            return '';
    }
}
exports.getReadingTypeLabel = getReadingTypeLabel;
/* istanbul ignore next */
function getWindowDimensions() {
    var width = window.innerWidth, height = window.innerHeight;
    return {
        width: width,
        height: height,
    };
}
/* istanbul ignore next */
function useWindowDimensions() {
    var _a = __read((0, react_1.useState)(getWindowDimensions()), 2), windowDimensions = _a[0], setWindowDimensions = _a[1];
    (0, react_1.useEffect)(function () {
        function handleResize() {
            setWindowDimensions(getWindowDimensions());
        }
        window.addEventListener('resize', handleResize);
        return function () { return window.removeEventListener('resize', handleResize); };
    }, []);
    return windowDimensions;
}
exports.useWindowDimensions = useWindowDimensions;
function withMPXN(value, mpxn) {
    return __assign(__assign({}, value), { mpxn: mpxn });
}
function mapMPXN(value, mpxn) {
    return value.map(function (v) { return withMPXN(v, mpxn); });
}
exports.mapMPXN = mapMPXN;
function filterReadsMPXN(value, mpxn) {
    return value.filter(function (read) { return read.mpxn === mpxn; });
}
exports.filterReadsMPXN = filterReadsMPXN;
function getSupplyMeterInfo(data, fuel, index) {
    if (index === void 0) { index = 0; }
    return data[fuel][index] || null;
}
exports.getSupplyMeterInfo = getSupplyMeterInfo;
var mostRecentFirst = function (a, b) {
    return (0, date_fns_1.isBefore)(a.readingDateTime, b.readingDateTime) ? 1 : -1;
};
exports.mostRecentFirst = mostRecentFirst;
function getLatestMeterExchangeReading(readings) {
    var meterExchangeReads = [
        'MexReadingInitial',
        'MexReadingInitialDeemed',
        'MexReadingInitialEstimated',
    ];
    return readings
        .sort(exports.mostRecentFirst)
        .find(function (r) { return meterExchangeReads.includes(r.readingType); });
}
exports.getLatestMeterExchangeReading = getLatestMeterExchangeReading;
var getTiersByRegisters = function (registers) {
    return registers.map(function (register) { return ({
        meterRegisterReading: parseInt(register.value, 10),
        //TODO - once MARS have defined a solution for the deprecated topic that
        //provides the timing category we need to come back to this and
        //remove the ternary operator
        //https://ovotech.atlassian.net/browse/CPCE-2100
        timeOfUseLabel: register.timingCategory
            ? (0, exports.timingCategoryToTimeOfUseLabel)(register.timingCategory) || 'anytime'
            : 'anytime',
    }); });
};
exports.getTiersByRegisters = getTiersByRegisters;
var hasComplexSupplies = function (supplies) {
    return supplies.filter(supply_points_1.isActiveElectricitySupply).length > 1;
};
exports.hasComplexSupplies = hasComplexSupplies;
var timingCategoryToTimeOfUseLabel = function (timingCategory) {
    switch (timingCategory) {
        case __generated__1.SupplyPointTimingCategory.EveningAndWeekend:
            return 'eveningandweekend';
        case __generated__1.SupplyPointTimingCategory.Heating:
            return 'heating';
        case __generated__1.SupplyPointTimingCategory.OffPeak:
            return 'offpeak';
        case __generated__1.SupplyPointTimingCategory.Peak:
            return 'peak';
        case __generated__1.SupplyPointTimingCategory.Anytime:
            return 'anytime';
        default:
            return null;
    }
};
exports.timingCategoryToTimeOfUseLabel = timingCategoryToTimeOfUseLabel;
var timeOfUseLabelToTimingCategory = function (timeOfUseLabel) {
    switch (timeOfUseLabel) {
        case 'eveningandweekend':
            return __generated__1.SupplyPointTimingCategory.EveningAndWeekend;
        case 'heating':
            return __generated__1.SupplyPointTimingCategory.Heating;
        case 'offpeak':
            return __generated__1.SupplyPointTimingCategory.OffPeak;
        case 'peak':
            return __generated__1.SupplyPointTimingCategory.Peak;
        case 'anytime':
            return __generated__1.SupplyPointTimingCategory.Anytime;
        default:
            return null;
    }
};
exports.timeOfUseLabelToTimingCategory = timeOfUseLabelToTimingCategory;
var getSupplyIndex = function (supplies, sprn) {
    var index = sprn ? supplies.findIndex(function (_a) {
        var mpxn = _a.mpxn;
        return mpxn === sprn;
    }) : -1;
    return index >= 0 ? index : undefined;
};
exports.getSupplyIndex = getSupplyIndex;
var groupSupplies = function (supplies) {
    var grouped = (0, groupBy_1.groupBy)(supplies, function (supply) { return supply.msn || 'no-msn'; });
    return Object.keys(grouped).reduce(function (acc, msn) {
        if (msn === 'no-msn') {
            acc.push.apply(acc, __spreadArray([], __read(grouped[msn].map(function (item) { return ({ msn: undefined, supplies: [item] }); })), false));
        }
        else {
            acc.push({
                msn: msn,
                supplies: grouped[msn],
            });
        }
        return acc;
    }, []);
};
exports.groupSupplies = groupSupplies;
var hasComplexSuppliesContext = function (supplies) { return supplies.filter(function (supply) { return supply.isActive; }).length > 1; };
exports.hasComplexSuppliesContext = hasComplexSuppliesContext;
function mapKapiElectricityMeterReadToLegacy(reading) {
    if (reading.type === __generated__1.ReadingType.Actual ||
        reading.type === __generated__1.ReadingType.Estimate) {
        var legacyReadingType = (0, core_1.newToLegacy)(reading.source, reading.type, reading.lifecycle);
        if (legacyReadingType) {
            return {
                readingDateTime: reading.dateTime,
                readingType: legacyReadingType,
                tiers: (0, exports.getTiersByRegisters)(reading.registers),
            };
        }
    }
    return null;
}
exports.mapKapiElectricityMeterReadToLegacy = mapKapiElectricityMeterReadToLegacy;
function mapKapiGasMeterReadToLegacy(reading) {
    if (reading.type === __generated__1.ReadingType.Actual ||
        reading.type === __generated__1.ReadingType.Estimate) {
        var legacyReadingType = (0, core_1.newToLegacy)(reading.source, reading.type, reading.lifecycle);
        if (legacyReadingType) {
            return {
                readingDateTime: reading.dateTime,
                readingType: legacyReadingType,
                gasVolume: Number(reading.value),
            };
        }
    }
    return null;
}
function mapKapiMeterReadToLegacy(reading) {
    if (reading.__typename === 'ElectricityMeterRead') {
        return mapKapiElectricityMeterReadToLegacy(reading);
    }
    if (reading.__typename === 'GasMeterRead') {
        return mapKapiGasMeterReadToLegacy(reading);
    }
    return null;
}
exports.mapKapiMeterReadToLegacy = mapKapiMeterReadToLegacy;
var filterTimingCategory = function (registers) {
    return !!registers.timingCategory;
};
exports.filterTimingCategory = filterTimingCategory;
var filterSupplies = function (supply) {
    return !!supply.registers;
};
exports.filterSupplies = filterSupplies;
var countMeters = function (supplies) {
    return supplies.reduce(function (acc, _a) {
        var msn = _a.msn;
        if (msn && !acc.includes(msn)) {
            acc.push(msn);
        }
        return acc;
    }, []).length;
};
exports.countMeters = countMeters;
var scrollTo = function (id) {
    var element = document.getElementById(id);
    if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
    }
};
exports.scrollTo = scrollTo;
var getNextSupplyIndex = function (currentIndex, totalSupplies) {
    // Doesnt have multiple supplies.
    if (totalSupplies < 2) {
        return null;
    }
    // Current not defined, treat as first.
    if (!currentIndex) {
        return 1;
    }
    // Current is the last item, loop back to first.
    if (Number(currentIndex) === totalSupplies - 1) {
        return 0;
    }
    // Current is not the last item, add 1.
    return Number(currentIndex) + 1;
};
exports.getNextSupplyIndex = getNextSupplyIndex;
